import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ProgressBarService } from '../../services/progress-bar.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ProgressBarComponent {
  progress: number = 0;
  completedRequests: number = 0;
  totalRequests: number = 0;

  constructor(private progressService: ProgressBarService) { }

  ngOnInit(): void {
    this.progressService.totalRequests$.subscribe(total => {
      this.totalRequests = total;
      this.updateProgress();
    });

    this.progressService.completedRequests$.subscribe(completed => {
      this.completedRequests = completed;
      this.updateProgress();
    });
  }

  updateProgress(): void {
    if (this.totalRequests > 0) {
      this.progress = (this.completedRequests / this.totalRequests) * 100;
    } else {
      this.progress = 0;
    }
  }
}
